module.exports = __webpack_public_path__ + "static/media/icon_cart_light.88b19986.svg";